import { DomainSerializer } from '../../global/serializables/domain.serializer';
import { LancamentoDespesa } from '../domain/lancamento-despesa.model';

export class LancamentoDespesaSerializer extends DomainSerializer<LancamentoDespesa> {}
